import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import InputModalFaculty from './InputModalFaculty'
import { toast } from 'react-toastify'
import { periodos } from 'data/constants'

const initialState = {
    nombre: '',
    fecha_inicio: '',
    fecha_fin: '',
    periodo: '',
    gestion: '',
}

const ModalFaculty = ({ faculty, setFaculty, show, onHide, update }) => {
    const [infoFaculty, setInfoFaculty] = useState(initialState)

    useEffect(() => {
        if (Object.keys(faculty).length !== 0) {
            setInfoFaculty(faculty)
        }
    }, [show])

    const handleOnChange = (e) => {
        setInfoFaculty({
            ...infoFaculty,
            [e.target.name]: e.target.value,
        })
    }

    const handleAcceptButton = () => {
        if (isValid(infoFaculty)) {
            onHide()
            update(infoFaculty)
            setFaculty({})
            setInfoFaculty(initialState)
        } else {
            toast.error('Fechas incorrectas!')
        }
    }

    const isValid = (infoFaculty) => {
        const { fecha_inicio, fecha_fin } = infoFaculty
        return fecha_inicio < fecha_fin
    }

    const handleExited = () => {
        setFaculty({})
        setInfoFaculty(initialState)
    }

    return (
        <Modal show={show} size='md' centered onExited={handleExited}>
            <Modal.Header>
                <span className='h4 mb-0'>Editar periodo</span>
            </Modal.Header>
            <Modal.Body>
                <InputModalFaculty
                    inputText='Facultad'
                    placeHolder='Nombre Facultad'
                    value={infoFaculty.nombre}
                    name='nombre'
                    type='text'
                    action={handleOnChange}
                    readonly='true'
                />

                <InputModalFaculty
                    inputText='Fecha Inicio'
                    placeHolder='01/01/2023'
                    value={infoFaculty.fecha_inicio}
                    name='fecha_inicio'
                    type='date'
                    action={handleOnChange}
                    readonly='false'
                    min={`${infoFaculty.gestion}-01-01`}
                />

                <InputModalFaculty
                    inputText='Fecha Fin'
                    placeHolder='01/06/2023'
                    value={infoFaculty.fecha_fin}
                    name='fecha_fin'
                    type='date'
                    action={handleOnChange}
                    readonly='false'
                    min={`${infoFaculty.gestion}-01-01`}
                />

                <InputModalFaculty
                    inputText='Gestión'
                    placeHolder='anual'
                    value={infoFaculty.gestion}
                    name='gestion'
                    type='text'
                    action={handleOnChange}
                    readonly='true'
                />
                <InputModalFaculty
                    inputText='Periodo'
                    placeHolder='1'
                    value={periodos[infoFaculty.periodo]}
                    name='periodo'
                    type='text'
                    action={handleOnChange}
                    readonly='true'
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide} variant='danger'>
                    Cancelar
                </Button>
                <Button onClick={handleAcceptButton} variant='blue'>
                    Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalFaculty
